import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ReactNode } from 'react';

export const MobileOnly = (props: { children: ReactNode; }) => {
  const { isMobile } = useMediaQuery();
  return isMobile ? <>{props.children}</>: null;
};
